import { useEffect, useRef } from "react"
import { useBlocker } from "react-router-dom"

/** Prompts with a native confirm on in-app route changes when `when` is true. */
export function useRouteLeaveConfirm(
  when: boolean,
  onLeave: () => void,
  message = "Leave this page? Progress may be lost."
) {
  const blocker = useBlocker(!!when)
  const lastKeyRef = useRef<string | null>(null)

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      lastKeyRef.current = null
      return
    }

    const key = blocker.location.key ?? '__nokey__'
    if (lastKeyRef.current === key) return
    lastKeyRef.current = key

    const ok = globalThis.confirm(message)
    if (ok) {
      try { onLeave() } catch {}
      setTimeout(() => { blocker.proceed() }, 0)
    } else {
      blocker.reset()
    }
  }, [blocker, onLeave, message])
}
